<script>
import Event from "./Event.vue";
import apiClient from "../../apiClient";

export default {
  name: "ConfrimOrder.vue",
  components: {Event},
  data() {
    return {
      message: 'Подтверждение заказа...'
    }
  },
  async mounted() {
    const { orderId, token } = this.$route.query

      apiClient.get('/api/order/confirm', {
        params: { orderId, token }
      }).then((res) => {
        this.message = 'Заказ подтвержден'
      }).catch(() => {
        this.message = 'Ошибка подтверждения заказа'
      })


  }

}
</script>

<template>
  <div class="confirm-layout">
    {{ message }}
  </div>
</template>

<style scoped>
.confirm-layout {
  display: flex;
  flex: 1;
  overflow-y: auto;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  padding: 50px 0;
}

.confirm-layout::-webkit-scrollbar {
  width: 8px;
  background: #FFFFFF;
}

.confirm-layout::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #5d5d62;
}
</style>



// WEBPACK FOOTER //
// src/components/client/ConfrimOrder.vue